import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, HeartHandshake } from "lucide-react";
import api from "../lib/api";
import Header from "../components/Header";
import UserNav from "../components/UserNav";

export default function PlanViewPage() {
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const pid = localStorage.getItem("rb_profile");
        const { data } = await api.get(`/profiles/${pid}/care-plan-friendly`);
        setSummary(data.friendly_summary);
      } catch { /* show empty state */ } finally {
        setLoaded(true);
      }
    })();
  }, []);

  return (
    <div data-testid="plan-view-page" className="min-h-screen bg-background">
      <Header />
      <main className="max-w-2xl mx-auto px-4 py-6 pb-32">
        <button data-testid="back-button" onClick={() => navigate("/use")} className="min-h-[48px] px-4 rounded-full border-2 border-foreground/25 bg-white font-bold flex items-center gap-2 hover:bg-secondary transition-colors duration-200">
          <ArrowLeft size={20} strokeWidth={2.5} /> Back
        </button>
        <div className="mt-6 bg-white rounded-3xl border-2 border-foreground/15 p-8 text-center">
          <HeartHandshake size={48} strokeWidth={2} className="text-primary mx-auto mb-4" />
          <h1 className="text-3xl font-extrabold mb-4">My plan</h1>
          {!loaded ? (
            <p className="text-lg text-muted-foreground">Loading…</p>
          ) : summary ? (
            <p data-testid="friendly-summary" className="text-xl font-semibold leading-relaxed">{summary}</p>
          ) : (
            <p data-testid="no-plan-message" className="text-lg text-muted-foreground">No care plan yet. Your carer can add one in Carer Mode.</p>
          )}
        </div>
      </main>
      <UserNav />
    </div>
  );
}
